<template>
<div :class="$style.panel">
    <p class="" v-html="message"></p>

    <div v-if="message===null" style="display:flex">
        <v-btn @click="clicked" :color="button_color" :dark="dark" nw-data="button_signIn" :class="$style.actionBtn">
            <template v-if="$store.getters.busy==0">
                <span style="text-transform: initial">
                    <str index="button > sign_in" />
                </span>
            </template>

            <v-progress-circular v-else indeterminate size="20"></v-progress-circular>
        </v-btn>  
    </div>
</div>
</template>

<script>
export default {
    name: "SignInButton",
    props: {
        color: {
            type: String,
            default: 'lightgrey'
        },
        button_message: {
            type: String,
            default: null
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            buttonLock: false,
            timer: null,
            waitMessage: null
        }
    },
    methods: {
        clicked: function(){
            var self = this;
            if(self.buttonLock===false){
                self.$emit('clicked');
            }else{
                self.waitMessage = 'Please wait';
            }
        },
        lock: function(){
            var self = this;

            self.buttonLock=true;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                self.buttonLock = false;
                self.waitMessage = null;
            },1000);
        }
    },
    computed:{
        button_color: function(){
            return this.waitMessage ? 'orange' : this.color;
        },
        message: function(){
            return this.waitMessage ? this.waitMessage : this.button_message;
        },
        busy: function(){
            return this.$store.getters.busy>0;
        }
    },
    watch: {
        busy: function(){
            if(this.busy===true){
                this.lock();
            }
        }
    }
}
</script>

<style module>
.panel {
    width:98%;
    display:block;
}

.panel p {
    font-size: 13px;
    color: #ff0000;
    margin-top: -40px;
}

.actionBtn {
    width: 150px;
    margin: 0 auto;
}
</style>